import axios from "axios";

// API Configuration
// Backup gateway: https://matching-platform-a2hldx2q.ew.gateway.dev
//
// On HTTPS pages (e.g. https://matching-platform.altosight.eu), defaults use
// same-origin paths so the browser never hits plain http:// (mixed content).
// Those paths require a reverse proxy — see deploy/nginx-matching-platform.conf.
// Override at build time with REACT_APP_* (see .env.example).

function resolveApiBases() {
    const envApi = process.env.REACT_APP_API_BASE;
    const envPredict = process.env.REACT_APP_PREDICT_BASE;
    const envSemantic = process.env.REACT_APP_PREDICT_SEMANTIC_BASE;

    if (envApi || envPredict || envSemantic) {
        const host =
            (typeof window !== "undefined" && window.location?.hostname) ||
            "localhost";
        return {
            api: envApi || `http://${host}:9099`,
            predict: envPredict || `http://${host}:9000`,
            semantic: envSemantic || `http://${host}:9001`,
        };
    }

    if (typeof window !== "undefined" && window.location.protocol === "https:") {
        return {
            api: "/api",
            predict: "/predict-svc",
            semantic: "/predict-semantic-svc",
        };
    }

    const host =
        (typeof window !== "undefined" && window.location?.hostname) ||
        "localhost";
    return {
        api: `http://${host}:9099`,
        predict: `http://${host}:9000`,
        semantic: `http://${host}:9001`,
    };
}

const { api: GCP_API_BASE, predict: PREDICT_SERVER_BASE, semantic: PREDICT_SEMANTIC_BASE } =
    resolveApiBases();
const API_KEY =
    process.env.REACT_APP_API_KEY || "AIzaSyDJasvWifm7p2ivFHH4VESnjZkLvG_Toxs";

// async function getApiData_fetch() {
//     // const data = { name: "json" };
//     try {
//         var response = await  fetch('https://matching-platform-a2hldx2q.ew.gateway.dev/eshops', {
//             method: 'get',
//
//             // headers: new Headers({
//             //     'Authorization' : 'API Key ' +btoa('x-api-key:AIzaSyDJasvWifm7p2ivFHH4VESnjZkLvG_Toxs')
//             // }),
//
//             headers: {
//                 'x-api-key':'AIzaSyDJasvWifm7p2ivFHH4VESnjZkLvG_Toxs',
//                 // "Content-Type":"application/json"
//             },
//
//             // headers: {
//             //     'Authorization':'x-api-key:AIzaSyDJasvWifm7p2ivFHH4VESnjZkLvG_Toxs',
//             //     // "Content-Type":"application/json"
//             // },
//
//             // body: JSON.stringify(data),
//             mode: 'no-cors',
//             // cache: 'default',
//             // redirect: "follow"
//         });
//         var data = await response.json();
//         return data ? data : " No Data";
//
//         // return data;
//     } catch (err) {
//         return err;
//     }
// }

// export const shopsData = async () => {
//     return await getApiData_axios();
//
// const data =null;
//
// console.log("- start  result_axios-");
// let result_axios = await getApiData_axios();
// console.log("result_axios: ", result_axios);
// console.log("- end  result_axios-");
//
// // console.log("- start  result_fetch-");
// // let result_fetch = await getApiData_fetch();
// // console.log("result_fetch: ", result_fetch);
// // console.log("- end  result_fetch-");
//
// return data;
// }



// ---------------------------------------- Helpers ---------------------------------------------
async function chunkArrayLoop(array, size) {
    let result = [];
    for (let i = 0; i < array.length; i += size) {
        let chunk = [];
        for (let j = i; j < i + size && j < array.length; j++) {
            chunk.push(array[j]);
        }
        result.push(chunk);
    }
    return result;
}
async function setPostData(unmatched_products) {
    const returnData = [];
    let postDataMatched = [];
    let postDataPredict = [];
    console.log("!!unmatched_products: ", unmatched_products);
    for (let i = 0; i < unmatched_products.length; i++) {
        const singleProduct = unmatched_products[i];
        const product_name = singleProduct.productname ? singleProduct.productname : null;
        const product_barcode = singleProduct.barcode ? singleProduct.barcode : null;
        const id_brand = singleProduct.product.brand.idBrand ? singleProduct.product.brand.idBrand : null;
        const url = singleProduct.url ? singleProduct.url : null;

        const obj_predict = {
            text: product_name,
            idBrand: id_brand,
            url: url
        };
        postDataPredict.push(obj_predict);

        const obj_match = {
            barcode: product_barcode,
            idBrand: id_brand,
            url: url
        };
        postDataMatched.push(obj_match);
    }
    returnData.push(postDataMatched);
    returnData.push(postDataPredict);
    return returnData;
}
// ----------------------------------------------------------------------------------------------





// ---------------------------------------- Load Drop Down Shops --------------------------------
async function getShops_axios() {
    try {
        const response = await axios.get(`${GCP_API_BASE}/eshops`, {
            method: 'GET',
            maxBodyLength: Infinity,
            headers: {
                'x-api-key': API_KEY,
            },
        });
        const data = await response.data;
        return data ? data : "No Data";
    } catch (err) {
        return err;
    }
}
export const shopsData = async () => {
    return await getShops_axios();
}
// ----------------------------------------------------------------------------------------------





// ---------------------------------------- Load Drop Down Brands -------------------------------
async function getBrands_axios() {
    try {
        const response = await axios.get(`${GCP_API_BASE}/brands`, {
            method: 'GET',
            maxBodyLength: Infinity,
            headers: {
                'x-api-key': API_KEY,
            },
            timeout: 60000
        });
        const data = await response.data;
        return data ? data : "No Data";
    } catch (err) {
        return err;
    }
}
export const brandsData = async () => {
    return await getBrands_axios();
}
// ----------------------------------------------------------------------------------------------





// ---------------------------------------- Load Unmatched Data ---------------------------------
async function getByEshopUnmatchedData_axios(eshopId) { // BY ESHOP
    try {
        // console.log("Eshop_id: ", eshopId)
        const response = await axios.get(`${GCP_API_BASE}/unmatched`, {
            method: 'GET',
            maxBodyLength: Infinity,
            headers: { 'x-api-key': API_KEY, },
            timeout: 60000,
            params: {
                idEshop: eshopId
            }
        });
        const unmatched = await response.data;
        return unmatched ? unmatched : "No Unmatched Data";
    } catch (err) {
        return err;
    }
}
async function getByBrandUnmatchedData_axios(brandId) { // BY Brand
    try {
        // console.log("Brand_id: ", brandId)
        const response = await axios.get(`${GCP_API_BASE}/unmatched`, {
            method: 'GET',
            maxBodyLength: Infinity,
            headers: { 'x-api-key': API_KEY, },
            timeout: 60000,
            params: {
                idBrand: brandId
            }
        });
        const unmatched = await response.data;
        return unmatched ? unmatched : "No Unmatched Data";

    } catch (err) {
        return err;
    }
}
// ----------------------------------------------------------------------------------------------





// ---------------------------------------- Load Predict Data -----------------------------------
async function predictChunksAPI(postDataPredict_chunks, useSemantic = false) {
    let responseData = [];
    const endpointBase = useSemantic ? PREDICT_SEMANTIC_BASE : PREDICT_SERVER_BASE;
    const endpointPath = useSemantic ? '/predict-semantic-batch' : '/predict';

    for (let i = 0; i < postDataPredict_chunks.length; i++) {
        try {
            if (useSemantic) {
                // Use batch endpoint for semantic matching (much faster)
                const documents = postDataPredict_chunks[i]
                    .filter(doc => doc.text) // Filter out empty texts
                    .map(doc => ({
                        text: doc.text,
                        brand: doc.idBrand
                    }));
                
                if (documents.length === 0) {
                    // No valid documents in this chunk
                    responseData.push(postDataPredict_chunks[i].map(() => {
                        const empty = {};
                        empty.matchConfidence = 0.0;
                        return empty;
                    }));
                    continue;
                }
                
                try {
                    const response = await axios.post(
                        `${endpointBase}${endpointPath}`,
                        { documents: documents },
                        {
                            timeout: 120000, // Increased timeout for batch processing
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }
                    );
                    
                    if (response.status === 200 && response.data.results) {
                        // Map results back to original chunk order
                        // The batch endpoint returns results in the same order as documents sent
                        const batchResults = response.data.results;
                        let batchResultIndex = 0;
                        
                        const predictions = postDataPredict_chunks[i].map((doc) => {
                            if (!doc.text) {
                                return { productId: -1, confidence: 0.0 };
                            }
                            // Results are in same order as documents (only valid docs were sent)
                            if (batchResultIndex < batchResults.length) {
                                const result = batchResults[batchResultIndex++];
                                return {
                                    productId: result.result !== -1 ? parseInt(result.result) : -1,
                                    confidence: result.confidence || 0.0
                                };
                            }
                            return { productId: -1, confidence: 0.0 };
                        });
                        
                        // Extract product IDs and confidence scores
                        const pids = predictions.map(p => p.productId);
                        const confidences = predictions.map(p => p.confidence);
                        
                        // Get unique product IDs and fetch product details
                        const uniquePids = [...new Set(pids.filter(pid => pid > 0))];
                        
                        if (uniquePids.length > 0) {
                            const productsResponse = await axios.post(
                                `${GCP_API_BASE}/products`,
                                { idProducts: uniquePids },
                                {
                                    headers: {
                                        'x-api-key': API_KEY,
                                        'Content-Type': 'application/json'
                                    },
                                    timeout: 60000
                                }
                            );

                            const productMap = {};
                            if (productsResponse.data && productsResponse.data.results) {
                                productsResponse.data.results.forEach(product => {
                                    productMap[product.idProduct] = product;
                                });
                            }

                            const chunkResults = pids.map((pid, index) => {
                                if (pid > 0 && productMap[pid]) {
                                    const product = { ...productMap[pid] };
                                    product.matchConfidence = confidences[index];
                                    return product;
                                }
                                const emptyResult = {};
                                emptyResult.matchConfidence = confidences[index];
                                return emptyResult;
                            });

                            responseData.push(chunkResults);
                        } else {
                            // No valid predictions, return empty objects with confidence
                            const emptyResults = pids.map((pid, index) => {
                                const empty = {};
                                empty.matchConfidence = confidences[index];
                                return empty;
                            });
                            responseData.push(emptyResults);
                        }
                    } else {
                        // Error response, return empty results
                        responseData.push(postDataPredict_chunks[i].map(() => {
                            const empty = {};
                            empty.matchConfidence = 0.0;
                            return empty;
                        }));
                    }
                } catch (err) {
                    console.log("predict batch error:", err);
                    // Return empty results on error
                    responseData.push(postDataPredict_chunks[i].map(() => {
                        const empty = {};
                        empty.matchConfidence = 0.0;
                        return empty;
                    }));
                }
                continue; // Skip the old individual request logic for semantic
            }
            
            // Classic /predict endpoint - use batch endpoint for better performance
            const documents = postDataPredict_chunks[i]
                .filter(doc => doc.text) // Filter out empty texts
                .map(doc => ({
                    text: doc.text,
                    brand: doc.idBrand
                }));
            
            if (documents.length === 0) {
                // No valid documents in this chunk
                responseData.push(postDataPredict_chunks[i].map(() => ({})));
                continue;
            }
            
            try {
                const response = await axios.post(
                    `${endpointBase}/predict-batch`,
                    { documents: documents },
                    {
                        timeout: 120000, // Increased timeout for batch processing
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );
                
                if (response.status === 200 && response.data.results) {
                    // Map results back to original chunk order
                    const batchResults = response.data.results;
                    let batchResultIndex = 0;
                    
                    const pids = postDataPredict_chunks[i].map((doc) => {
                        if (!doc.text) {
                            return -1;
                        }
                        // Results are in same order as documents (only valid docs were sent)
                        if (batchResultIndex < batchResults.length) {
                            const result = batchResults[batchResultIndex++];
                            return result.result !== -1 ? parseInt(result.result) : -1;
                        }
                        return -1;
                    });
                    
                    // Get unique product IDs and fetch product details
                    const uniquePids = [...new Set(pids.filter(pid => pid > 0))];
                    
                    if (uniquePids.length > 0) {
                        const productsResponse = await axios.post(
                            `${GCP_API_BASE}/products`,
                            { idProducts: uniquePids },
                            {
                                headers: {
                                    'x-api-key': API_KEY,
                                    'Content-Type': 'application/json'
                                },
                                timeout: 60000
                            }
                        );

                        const productMap = {};
                        if (productsResponse.data && productsResponse.data.results) {
                            productsResponse.data.results.forEach(product => {
                                productMap[product.idProduct] = product;
                            });
                        }

                        const chunkResults = pids.map((pid) => {
                            if (pid > 0 && productMap[pid]) {
                                return productMap[pid];
                            }
                            return {};
                        });

                        responseData.push(chunkResults);
                    } else {
                        // No valid predictions, return empty objects
                        responseData.push(pids.map(() => ({})));
                    }
                } else {
                    // Error response, return empty results
                    responseData.push(postDataPredict_chunks[i].map(() => ({})));
                }
            } catch (err) {
                console.log("predict batch error:", err);
                // Return empty results on error
                responseData.push(postDataPredict_chunks[i].map(() => ({})));
            }
            continue; // Skip the old individual request logic (now handled by batch endpoints above)
        } catch (err) {
            console.log("response_predict_data ERROR::::: ", err);
            // Return empty objects for this chunk
            responseData.push(postDataPredict_chunks[i].map(() => ({})));
        }
    }
    
    // Flatten the results
    let dd = []
    for (let i = 0; i < responseData.length; i++) {
        const innerArray = responseData[i];
        for (let j = 0; j < innerArray.length; j++) {
            dd.push(innerArray[j])
        }
    }

    return dd;
}
// ----------------------------------------------------------------------------------------------




// ---------------------------------------- Load Matched Data -----------------------------------
async function matchChunksAPI(postDataMatched_chunks) {
    let responseData = [];
    for (let i = 0; i < postDataMatched_chunks.length; i++) {
        try {
            let config_match = {
                method: 'post',
                timeout: 600000,
                maxBodyLength: Infinity,
                url: `${GCP_API_BASE}/match`,
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                data: {"documents": postDataMatched_chunks[i]}
            };
            const response_match = await axios.request(config_match);
            responseData.push(response_match.data.results);
        } catch (err) {
            console.log("response_match_data ERROR::::: ", err);
        }
    }

    let dd = []
    for (let i = 0; i < responseData.length; i++) {
        const innerArray = responseData[i];
        for (let j = 0; j < innerArray.length; j++) {
            dd.push(innerArray[j])
        }
    }
    console.log("dd: ", dd);
    return dd;
}
// ----------------------------------------------------------------------------------------------





// --------------------------- table data BY ESHOP ----------------------------------------------
export const byEshopTableData = async (eshopId, onProgress = null, useSemantic = false) => {
    const unmatched_products_by_eshop_id = await getByEshopUnmatchedData_axios(eshopId);
    console.log("Return Unmatched Data By Eshop: ", unmatched_products_by_eshop_id);
    const products_by_eshop_id_for_table = await  fetchUnmatchedDataByEshop(unmatched_products_by_eshop_id.results, onProgress, useSemantic);
    console.log("products_by_eshop_id_for_table: ", products_by_eshop_id_for_table);
    return products_by_eshop_id_for_table;

    // return await getBrands_axios();
    // await match apo kato ta unmatched kai sto telos return object me ola
}
async function fetchUnmatchedDataByEshop(unmatched_products_by_eshop_id, onProgress = null, useSemantic = false) {
    let tableData = [];
    console.log("unmatched_products_by_eshop.length - Left: ", unmatched_products_by_eshop_id.length);
    console.log("!!!!!unmatched_products_by_eshop.length - Left: ", unmatched_products_by_eshop_id);

    const allPostData = await setPostData(unmatched_products_by_eshop_id);
    const postDataMatched = allPostData[0];
    const postDataPredict = allPostData[1];

    console.log("postDataMatched_: ", postDataMatched);
    console.log("postDataPredict_: ", postDataPredict);

    const postDataPredict_chunks = await chunkArrayLoop(postDataPredict, 500);
    console.log("postDataPredict_chunks: ", postDataPredict_chunks);
    const postDataMatched_chunks = await chunkArrayLoop(postDataMatched, 500);
    console.log("postDataMatched_chunks: ", postDataMatched_chunks);

    if (onProgress) onProgress("Predicting matches...");
    const predictData = await predictChunksAPI(postDataPredict_chunks, useSemantic);
    console.log("__response predict Data__: ", predictData);
    
    if (onProgress) onProgress("Matching products...");
    const matchData = await matchChunksAPI(postDataMatched_chunks);
    console.log("__response match Data__: ", matchData);

    // Collect auto-matchable rows and send them via bulk API. Exclude them from table.
    const autoMatchPayloads = [];

    for (let i = 0; i < unmatched_products_by_eshop_id.length; i++) {
        const singleUnmatchedProduct = unmatched_products_by_eshop_id[i];
        const singlePredictProduct = predictData[i];
        const singleMatchProduct = matchData[i];

        const leftBarcode = singleUnmatchedProduct.barcode;
        const predictHasSameBarcode = !!(
            singlePredictProduct &&
            Array.isArray(singlePredictProduct.barcodes) &&
            leftBarcode &&
            singlePredictProduct.barcodes.includes(leftBarcode)
        );

        // If barcode exists and we have a confident right product, auto-match.
        let autoMatchRightId = null;
        if (leftBarcode && singleMatchProduct && singleMatchProduct.idProduct) {
            autoMatchRightId = singleMatchProduct.idProduct;
        } else if (leftBarcode && predictHasSameBarcode && singlePredictProduct && singlePredictProduct.idProduct) {
            autoMatchRightId = singlePredictProduct.idProduct;
        
        }

        if (autoMatchRightId) {
            autoMatchPayloads.push({
                url: singleUnmatchedProduct.url,
                idProduct: autoMatchRightId,
                idEshop: singleUnmatchedProduct.eshop.idEshop
            });
            // continue; // exclude autoMatch from table
        }

        // Otherwise keep it for manual handling with proposed right side.
        let productRight = null;
        if (singleMatchProduct && singleMatchProduct.idProduct) {
            productRight = singleMatchProduct;  // Use match result when available
        } else if (singlePredictProduct && singlePredictProduct.idProduct) {
            productRight = singlePredictProduct;  // Fall back to predict result
        }

        
        // Check if barcode matches either from /match API or /predict API
        const hasMatchFromMatchAPI = !!(leftBarcode && singleMatchProduct && singleMatchProduct.idProduct);
        const hasMatchFromPredictAPI = !!(leftBarcode && singlePredictProduct?.barcodes && singlePredictProduct.barcodes.includes(leftBarcode));
        const barcodeMatch = hasMatchFromMatchAPI || hasMatchFromPredictAPI;
        
        // Calculate confidence: 100% if barcode matches, otherwise use semantic confidence
        let matchConfidence = singlePredictProduct?.matchConfidence || null;
        if (barcodeMatch && productRight?.idProduct) {
            // Barcode match = 100% confidence (definitive match)
            matchConfidence = 1.0;
        }
        
        const product = {
            productIndex: i,
            eshop_id: singleUnmatchedProduct.eshop.idEshop,
            eshop_name: singleUnmatchedProduct.eshop.name,
            product_name: singleUnmatchedProduct.productname,
            product_barcode: leftBarcode,
            product_brand_name: singleUnmatchedProduct.brandname,
            product_photo_left: singleUnmatchedProduct.imgurl,
            data_from_db : leftBarcode ? 1 : 0,
            url: singleUnmatchedProduct.url,
            rightProductId : productRight?.idProduct,
            rightProductName : productRight?.name,
            barcodeMatch: barcodeMatch,
            matchConfidence: matchConfidence
        };
        tableData.push(product);
    }

    // Semantic search: sort products + suggestions by confidence descending
    if (useSemantic) {
        tableData.sort((a, b) => (b.matchConfidence ?? 0) - (a.matchConfidence ?? 0));
    }

    // Do not post automatically; return payloads for manual posting in UI
    console.log("tableData: ", tableData);
    return { rows: tableData, autoMatchPayloads };
}
// ----------------------------------------------------------------------------------------------





// ----------------------- table data BY BRAND --------------------------------------------------
export const byBrandTableData = async (brandId, onProgress = null, useSemantic = false) => {
    const unmatched_products_by_brand_id = await getByBrandUnmatchedData_axios(brandId);
    console.log("Return Unmatched Data By Brand: ", unmatched_products_by_brand_id);
    const products_by_brand_id_for_table = await fetchUnmatchedDataByEshop(unmatched_products_by_brand_id.results, onProgress, useSemantic);
    console.log("products_by_brand_id_for_table: ", products_by_brand_id_for_table);
    return products_by_brand_id_for_table
}
// ----------------------------------------------------------------------------------------------





// ---------------------------------------- Load Product From Brand To Manual Pick --------------------------------
async function getProducts_axios(brandId) {
    try {
        const response = await axios.post(
            `${GCP_API_BASE}/products`,
            { idBrand: brandId },
            {
                maxBodyLength: Infinity,
                headers: {
                    'x-api-key': API_KEY,
                    'Content-Type': 'application/json'
                },
                timeout: 60000
            }
        );
        const data = await response.data;
        return data ? data : "No Data";
    } catch (err) {
        return err;
    }
}
export const manualPickProductsFromBrandID = async (brandId) => {
    return await getProducts_axios(brandId);
}
// ----------------------------------------------------------------------------------------------





// ----------------------------------------  Match  Data  --------------------------------
/**
 * Match a single product (set crawl with product ID)
 * @param {Object} productRow - Product row with url, rightProductId, eshop_id
 * @returns {Promise<Object>} - {success: boolean, data?: any, error?: Object}
 */
export const matchProducts = async (productRow) => {
    try {
        const response = await axios.post(
            `${GCP_API_BASE}/set-crawl`,
            {
                url: productRow.url,
                idProduct: productRow.rightProductId,
                idEshop: productRow.eshop_id
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                timeout: 60000
            }
        );
        
        return {
            success: true,
            data: response.data
        };
    } catch (err) {
        return {
            success: false,
            error: {
                message: err.message || 'Failed to match product',
                response: err.response?.data,
                status: err.response?.status,
                url: productRow.url
            }
        };
    }
}

/**
 * Match multiple products in bulk
 * @param {Array} bulkProducts - Array of product objects with url, idProduct, idEshop
 * @returns {Promise<Object>} - {success: boolean, data?: any, error?: Object, results?: Array}
 */
export const matchProductsBulk = async (bulkProducts) => {
    try {
        const response = await axios.post(
            `${GCP_API_BASE}/set-crawl-bulk`,
            bulkProducts,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                timeout: 120000 // Longer timeout for bulk operations
            }
        );
        
        return {
            success: true,
            data: response.data,
            results: response.data?.results || []
        };
    } catch (err) {
        return {
            success: false,
            error: {
                message: err.message || 'Failed to match products in bulk',
                response: err.response?.data,
                status: err.response?.status
            }
        };
    }
}
// ----------------------------------------------------------------------------------------------





// ----------------------------------------  Delete  Data  --------------------------------
/**
 * Delete a product crawl
 * @param {Object} productRow - Product row with url
 * @returns {Promise<Object>} - {success: boolean, data?: any, error?: Object}
 */
export const deleteProducts = async (productRow) => {
    try {
        const response = await axios.post(
            `${GCP_API_BASE}/delete-crawl`,
            {
                url: productRow.url
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                timeout: 60000
            }
        );
        
        return {
            success: true,
            data: response.data
        };
    } catch (err) {
        return {
            success: false,
            error: {
                message: err.message || 'Failed to delete product',
                response: err.response?.data,
                status: err.response?.status,
                url: productRow.url
            }
        };
    }
}
// ----------------------------------------------------------------------------------------------





// ----------------------------------------  Remove  Data  --------------------------------
/**
 * Remove a product (set crawl with idProduct = -1)
 * @param {Object} productRow - Product row with url, eshop_id
 * @returns {Promise<Object>} - {success: boolean, data?: any, error?: Object}
 */
export const removeProducts = async (productRow) => {
    try {
        const response = await axios.post(
            `${GCP_API_BASE}/set-crawl`,
            {
                url: productRow.url,
                idProduct: -1,
                idEshop: productRow.eshop_id
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': API_KEY
                },
                timeout: 60000
            }
        );
        
        return {
            success: true,
            data: response.data
        };
    } catch (err) {
        return {
            success: false,
            error: {
                message: err.message || 'Failed to remove product',
                response: err.response?.data,
                status: err.response?.status,
                url: productRow.url
            }
        };
    }
}
// ----------------------------------------------------------------------------------------------

